import { runApp } from "@eusoft/webapp-framework";
import { PmApp } from "./PmApp";
import "./lang/IT";
import "./App.scss";

runApp(new PmApp());